module.exports = __webpack_public_path__ + "media/images/lb/400-9654b676c5ede0ae44c8e03ede42a809.svg";